import React from "react";
import "./HomeSections.css";
import GuidanceImg from  "../../assets/Image/NewImages/PersonalGuidance.jpeg";
import { Link } from "react-router-dom";

function PersonalGuidance() {
  return (
    <section className="section-wrapper light-bg">
      <div className="container row valign-wrapper flex-wrap">
        <div className="col l6 s12">
          <h4>Personalised Guidance from Experts</h4>
          <p>
            Plan your career, stream/ subject combinations, course, college and
            more through expert guidance.
          </p>
          <p>
            All our career coaches are International Certified Career Coaches
            who have mentored over 3 Million students.
          </p>
          <p>Make the right choice with personalised career counselling.</p>

          {/* <button className="custom-btn">About Our Team</button> */}
          <Link to="/about" className="custom-btn">
            About Our Team
          </Link>
        </div>

        <div className="col l6 s12 center">
          <img src={GuidanceImg} alt="" className="responsive-img custom-img" />
        </div>
      </div>
    </section>
  );
}

export default PersonalGuidance;
